import { render, staticRenderFns } from "./VolunteerProfileDetails.vue?vue&type=template&id=dd525b24&scoped=true"
import script from "./VolunteerProfileDetails.vue?vue&type=script&lang=js"
export * from "./VolunteerProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./VolunteerProfileDetails.vue?vue&type=style&index=0&id=dd525b24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd525b24",
  null
  
)

export default component.exports